import axios from 'axios';
import { toast } from 'react-toastify';
import { isExpired, getAccessToken, getLoginAccessToken, isLoggedIn, SESSION_EXPIRED_EVENT } from './utilities';
import settings from '../config/settings';
import { isDesktop } from '../setup/desktopApi';
// import { jwtDecode } from "jwt-decode";

var api = axios.create({
    baseURL: settings.ROOT_URL,
    headers: settings.headers
});

// const isTokenExpired = () => {
//     const decoded = jwtDecode(getAccessToken());
//     return decoded.iat > Date.now();
// }

api.interceptors.request.use((config) => {
    //console.log(isTokenExpired());
    let headers = { ...config.headers };
    if (getLoginAccessToken() || getAccessToken()) {
        headers['Authorization'] = `Bearer ${getLoginAccessToken() ? getLoginAccessToken() : getAccessToken()}`
    }
    let conf = {
        ...config,
        headers: headers,
    }
    return conf;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
api.interceptors.response.use((response) => {
    return response;
}, (error) => {
    toast.dismiss();
    if (error?.response?.status === 401) {
        if (isDesktop() && isLoggedIn()) {
            // Desktop: re-authenticate in place (ReauthDialog). isExpired() wipes the session
            // and navigates to /login, discarding whatever is on screen — a half-entered bill
            // on a POS terminal — because one background request saw an expired token.
            window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
        } else {
            isExpired();
        }
    } else if (error?.response === undefined) {
        // No response (e.g. offline / network failure). Don't dereference the
        // undefined response — just attach a friendly message and reject so
        // callers (including the offline repository) can detect "no response".
        error.message = 'System error. Try again if problem presist Contact your application support';
    } else if (error?.response?.status === 404) {
        //toast('Page not found');
        //window.location.href = "/404";
    } else if (error?.response?.status === 500) {
        //error.response.data.error.message = 'System error. Try again if problem presist Contact your application support';
        toast.error(error?.response?.data?.error?.message || 'System error. Try again if problem presist Contact your application support');
    } else if (error?.response?.status === 502) {
        error.response.data.error.message = 'Server error. Please check terminal path';
        toast.error('Server error. Please check terminal path');
    }
    return Promise.reject(error);
});

export default api;
